import tinycolor from 'tinycolor2';

import { BLUE, WHITE } from '../../../configs/colors';
import { getContrastedColor } from '../../../utils/getContrastedColor';

const BAR_BORDER = 'rgba(0,0,0,0.05)';
const PROGRESS_DARKEN = 12;

// Хелпер для формирования css-селектора: если брать просто id, то по итогу может получиться класс .wx-bar.wx-task.1 - недопустимый CSS-селектор
export const statusTaskType = (statusId) => `status_${statusId}`;

// Формирует контрастный текст и прогресс
const toBarColors = (color) => {
  const bg = tinycolor.equals(color, WHITE) ? '#f8f8f8' : tinycolor(color).toHexString();

  return {
    bg,
    fg: getContrastedColor(bg),
    fill: tinycolor(bg).darken(PROGRESS_DARKEN).toHexString(),
    border: BAR_BORDER,
  };
};

const taskColorCss = (scope, type, color) => {
  const { bg, fg, fill, border } = toBarColors(color);
  return `${scope} .wx-bar.wx-task${type === 'task' ? '' : `.${type}`} {
    --wx-gantt-task-color: ${bg};
    --wx-gantt-task-font-color: ${fg};
    --wx-gantt-task-fill-color: ${fill};
    --wx-gantt-task-border-color: ${border};
  }`;
};

// Подготовка списка типов задач и CSS с их цветами
export function buildTaskColors(colorField, scope) {
  const taskTypes = [{ id: 'task', label: 'task' }];
  let css = taskColorCss(scope, 'task', BLUE);
  const items = colorField && colorField.getIn(['config', 'items']);

  if (items) {
    items.forEach((item) => {
      const type = statusTaskType(item.get('id'));
      taskTypes.push({ id: type, label: item.get('name') });
      css += taskColorCss(scope, type, item.get('color') || BLUE);
    });
  }

  return { taskTypes, css };
}
